const lunarInfo = [
  0x6b50,
  0x2ba0,
  0xab62,
  0x9370,
  0x52e6,
  0xd160,
  0xe4b0,
  0x6d25,
  0xda90,
  0x5b50, // 1801 ~ 1810
  0x36d3,
  0x2ae0,
  0xa2e0,
  0xe2d2,
  0xc950,
  0xd556,
  0xb520,
  0xb690,
  0x5da4,
  0x55d0, // 1811 ~ 1820
  0x25d0,
  0xa5b3,
  0xa2b0,
  0xa8b7,
  0xa95f,
  0xb4a0,
  0xb2a5,
  0xad5f,
  0x55b0,
  0x2b74, // 1821 ~ 1830
  0x2570,
  0x52f9,
  0x52b0,
  0x6950,
  0x6d56,
  0x5aa0,
  0xab50,
  0x56d4,
  0x4ae0,
  0xa570, // 1831 ~ 1840
  0x4553,
  0xd2af,
  0xe8a7,
  0xd55f,
  0x5aa0,
  0xada5,
  0x95d0,
  0x4ae0,
  0xaab4,
  0xa4d0, // 1841 ~ 1850
  0xd2b8,
  0xb290,
  0xb550,
  0x5757,
  0x2da0,
  0x95d0,
  0x4d75,
  0x49b0,
  0xa4b0,
  0xa4b3, // 1851 ~ 1860
  0x6a9f,
  0xad98,
  0x6b50,
  0x2b60,
  0x9365,
  0x937f,
  0x4970,
  0x6964,
  0xe4a0,
  0xea6a, // 1861 ~ 1870
  0xda90,
  0x5ad0,
  0x2ad6,
  0x2aef,
  0x92e0,
  0xcad5,
  0xc950,
  0xd4a0,
  0xd4a3,
  0xb69f, // 1871 ~ 1880
  0x57a7,
  0x55b0,
  0x25d0,
  0x95b5,
  0x92b0,
  0xa950,
  0xd954,
  0xb4a0,
  0xb550,
  0x6d52, // 1881 ~ 1890
  0x55b0,
  0x2776,
  0x2570,
  0x52b0,
  0xaaa5,
  0xe950,
  0x6aa0,
  0xbaa3,
  0xab50,
  0x4bd8, // 1891 ~ 1900

  0x4ae0,
  0xa570,
  0x54d5,
  0xd260,
  0xd950,
  0x16554 /*0x5554*/,
  0x56af,
  0x9ad0,
  0x55d2,
  0x4ae0, // 1901 ~ 1910
  0xa5b6,
  0xa4d0,
  0xd250,
  0xd255,
  0xb54f,
  0xd6a0,
  0xada2,
  0x95b0,
  0x4977,
  0x497f, // 1911 ~ 1920
  0xa4b0,
  0xb4b5,
  0x6a50,
  0x6d40,
  0xab54,
  0x2b6f,
  0x9570,
  0x52f2,
  0x4970,
  0x6566, // 1921 ~ 1930
  0xd4a0,
  0xea50,
  /* 0x6a95, 0x5adf*/ 0x06e95,
  0x05ad0,
  0x2b60,
  0x86e3,
  0x92ef,
  0xc8d7,
  0xc95f,
  0xd4a0, // 1931 ~ 1940
  0xd8a6,
  0xb55f,
  0x56a0,
  0xa5b4,
  0x25df,
  0x92d0,
  0xd2b2,
  0xa950,
  0xb557,
  0x6ca0, // 1941 ~ 1950
  0xb550,
  0x5355,
  0x4daf,
  0xa5b0,
  0x4573,
  0x52bf,
  0xa9a8,
  0xe950,
  0x6aa0,
  0xaea6, // 1951 ~ 1960
  0xab50,
  0x4b60,
  0xaae4,
  0xa570,
  0x5260,
  0xf263,
  0xd950,
  0x5b57,
  0x56a0,
  0x96d0, // 1961 ~ 1970
  0x4dd5,
  0x4ad0,
  0xa4d0,
  0xd4d4,
  0xd250,
  0xd558,
  0xb540,
  0xb6a0,
  0x95a6,
  0x95bf, // 1971 ~ 1980
  0x49b0,
  0xa974,
  0xa4b0,
  0xb27a,
  0x6a50,
  0x6d40,
  0xaf46,
  0xab60,
  0x9570,
  0x4af5, // 1981 ~ 1990
  0x4970,
  0x64b0,
  0x74a3,
  0xea50,
  0x6b58,
  0x5ac0,
  0xab60,
  0x96d5,
  0x92e0,
  0xc960, // 1991 ~ 2000

  0xd954,
  0xd4a0,
  0xda50,
  0x7552,
  0x56a0,
  0xabb7,
  0x25d0,
  0x92d0,
  0xcab5,
  0xa950, // 2001 ~ 2010
  0xb4a0,
  0xbaa4,
  0xad50,
  0x55d9,
  0x4ba0,
  0xa5b0,
  0x5176,
  0x52bf,
  0xa930,
  0x7954, // 2011 ~ 2020
  0x6aa0,
  0xad50,
  0x5b52,
  0x4b60,
  0xa6e6,
  0xa4e0,
  0xd260,
  0xea65,
  0xd530,
  0x5aa0, // 2021 ~ 2030
  0x76a3,
  0x96d0,
  0x4afb,
  0x4ad0,
  0xa4d0,
  0xd0b6,
  0xd25f,
  0xd520,
  0xdd45,
  0xb5a0, // 2031 ~ 2040
  0x56d0,
  0x55b2,
  0x49b0,
  0xa577,
  0xa4b0,
  0xaa50,
  0xb255,
  0x6d2f,
  0xada0,
  0x4b63, // 2041 ~ 2050
  0x937f,
  0x49f8,
  0x4970,
  0x64b0,
  0x68a6,
  0xea5f,
  0x6b20,
  0xa6c4,
  0xaaef,
  0x92e0, // 2051 ~ 2060
  0xd2e3,
  0xc960,
  0xd557,
  0xd4a0,
  0xda50,
  0x5d55,
  0x56a0,
  0xa6d0,
  0x55d4,
  0x52d0, // 2061 ~ 2070
  0xa9b8,
  0xa950,
  0xb4a0,
  0xb6a6,
  0xad50,
  0x55a0,
  0xaba4,
  0xa5b0,
  0x52b0,
  0xb273, // 2071 ~ 2080
  0x6930,
  0x7337,
  0x6aa0,
  0xad50,
  0x4b55,
  0x4b6f,
  0xa570,
  0x54e4,
  0xd260,
  0xe968, // 2081 ~ 2090
  0xd520,
  0xdaa0,
  0x6aa6,
  0x56df,
  0x4ae0,
  0xa9d4,
  0xa4d0,
  0xd150,
  0xf252,
  0xd520, // 2091 ~ 2100
]

var monthArray = [
  '正月',
  '二月',
  '三月',
  '四月',
  '五月',
  '六月',
  '七月',
  '八月',
  '九月',
  '十月',
  '冬月',
  '腊月',
]
var dayArray = [
  '初一',
  '初二',
  '初三',
  '初四',
  '初五',
  '初六',
  '初七',
  '初八',
  '初九',
  '初十',
  '十一',
  '十二',
  '十三',
  '十四',
  '十五',
  '十六',
  '十七',
  '十八',
  '十九',
  '廿十',
  '廿一',
  '廿二',
  '廿三',
  '廿四',
  '廿五',
  '廿六',
  '廿七',
  '廿八',
  '廿九',
  '卅十',
]

const lunarYears = [
  1801, 1802, 1803, 1804, 1805, 1806, 1807, 1808, 1809, 1810, 1811, 1812, 1813,
  1814, 1815, 1816, 1817, 1818, 1819, 1820, 1821, 1822, 1823, 1824, 1825, 1826,
  1827, 1828, 1829, 1830, 1831, 1832, 1833, 1834, 1835, 1836, 1837, 1838, 1839,
  1840, 1841, 1842, 1843, 1844, 1845, 1846, 1847, 1848, 1849, 1850, 1851, 1852,
  1853, 1854, 1855, 1856, 1857, 1858, 1859, 1860, 1861, 1862, 1863, 1864, 1865,
  1866, 1867, 1868, 1869, 1870, 1871, 1872, 1873, 1874, 1875, 1876, 1877, 1878,
  1879, 1880, 1881, 1882, 1883, 1884, 1885, 1886, 1887, 1888, 1889, 1890, 1891,
  1892, 1893, 1894, 1895, 1896, 1897, 1898, 1899, 1900, 1901, 1902, 1903, 1904,
  1905, 1906, 1907, 1908, 1909, 1910, 1911, 1912, 1913, 1914, 1915, 1916, 1917,
  1918, 1919, 1920, 1921, 1922, 1923, 1924, 1925, 1926, 1927, 1928, 1929, 1930,
  1931, 1932, 1933, 1934, 1935, 1936, 1937, 1938, 1939, 1940, 1941, 1942, 1943,
  1944, 1945, 1946, 1947, 1948, 1949, 1950, 1951, 1952, 1953, 1954, 1955, 1956,
  1957, 1958, 1959, 1960, 1961, 1962, 1963, 1964, 1965, 1966, 1967, 1968, 1969,
  1970, 1971, 1972, 1973, 1974, 1975, 1976, 1977, 1978, 1979, 1980, 1981, 1982,
  1983, 1984, 1985, 1986, 1987, 1988, 1989, 1990, 1991, 1992, 1993, 1994, 1995,
  1996, 1997, 1998, 1999, 2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008,
  2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021,
  2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030, 2031, 2032, 2033, 2034,
  2035, 2036, 2037, 2038, 2039, 2040, 2041, 2042, 2043, 2044, 2045, 2046, 2047,
  2048, 2049, 2050, 2051, 2052, 2053, 2054, 2055, 2056, 2057, 2058, 2059, 2060,
  2061, 2062, 2063, 2064, 2065, 2066, 2067, 2068, 2069, 2070, 2071, 2072, 2073,
  2074, 2075, 2076, 2077, 2078, 2079, 2080, 2081, 2082, 2083, 2084, 2085, 2086,
  2087, 2088, 2089, 2090, 2091, 2092, 2093, 2094, 2095, 2096, 2097, 2098, 2099,
]

/**
 * 时差表,日期，修正时间，加减（1加，-1减）
 * */
var ShiChaXiuZheng = [
  ['1月1日', '0:03:09', '-1'],
  ['1月2日', '0:03:38', '-1'],
  ['1月3日', '0:04:06', '-1'],
  ['1月4日', '0:04:33', '-1'],
  ['1月5日', '0:05:01', '-1'],
  ['1月6日', '0:05:27', '-1'],
  ['1月7日', '0:05:54', '-1'],
  ['1月8日', '0:06:20', '-1'],
  ['1月9日', '0:06:45', '-1'],
  ['1月10日', '0:07:10', '-1'],
  ['1月11日', '0:07:35', '-1'],
  ['1月12日', '0:07:59', '-1'],
  ['1月13日', '0:08:22', '-1'],
  ['1月14日', '0:08:45', '-1'],
  ['1月15日', '0:09:07', '-1'],
  ['1月16日', '0:09:28', '-1'],
  ['1月17日', '0:09:49', '-1'],
  ['1月18日', '0:10:09', '-1'],
  ['1月19日', '0:10:28', '-1'],
  ['1月20日', '0:10:47', '-1'],
  ['1月21日', '0:11:05', '-1'],
  ['1月22日', '0:11:22', '-1'],
  ['1月23日', '0:11:38', '-1'],
  ['1月24日', '0:11:54', '-1'],
  ['1月25日', '0:12:08', '-1'],
  ['1月26日', '0:12:22', '-1'],
  ['1月27日', '0:12:35', '-1'],
  ['1月28日', '0:12:59', '-1'],
  ['1月29日', '0:13:10', '-1'],
  ['1月30日', '0:13:19', '-1'],
  ['1月31日', '0:13:37', '-1'],

  ['2月1日', '0:13:44', '-1'],
  ['2月2日', '0:13:50', '-1'],
  ['2月3日', '0:13:56', '-1'],
  ['2月4日', '0:14:01', '-1'],
  ['2月5日', '0:14:05', '-1'],
  ['2月6日', '0:14:09', '-1'],
  ['2月7日', '0:14:11', '-1'],
  ['2月8日', '0:14:13', '-1'],
  ['2月9日', '0:14:14', '-1'],
  ['2月10日', '0:14:15', '-1'],
  ['2月11日', '0:14:14', '-1'],
  ['2月12日', '0:14:13', '-1'],
  ['2月13日', '0:14:11', '-1'],
  ['2月14日', '0:14:08', '-1'],
  ['2月15日', '0:14:05', '-1'],
  ['2月16日', '0:14:01', '-1'],
  ['2月17日', '0:13:56', '-1'],
  ['2月18日', '0:13:51', '-1'],
  ['2月19日', '0:13:44', '-1'],
  ['2月20日', '0:13:38', '-1'],
  ['2月21日', '0:13:30', '-1'],
  ['2月22日', '0:13:22', '-1'],
  ['2月23日', '0:13:13', '-1'],
  ['2月24日', '0:11:04', '-1'],
  ['2月25日', '0:12:54', '-1'],
  ['2月26日', '0:12:43', '-1'],
  ['2月27日', '0:12:32', '-1'],
  ['2月28日', '0:12:21', '-1'],
  ['2月29日', '0:12:08', '-1'],

  ['3月1日', '0:11:56', '-1'],
  ['3月2日', '0:11:43', '-1'],
  ['3月3日', '0:11:29', '-1'],
  ['3月4日', '0:11:15', '-1'],
  ['3月5日', '0:11:01', '-1'],
  ['3月6日', '0:10:47', '-1'],
  ['3月7日', '0:10:32', '-1'],
  ['3月8日', '0:10:16', '-1'],
  ['3月9日', '0:10:01', '-1'],
  ['3月10日', '0:09:45', '-1'],
  ['3月11日', '0:09:28', '-1'],
  ['3月12日', '0:09:12', '-1'],
  ['3月13日', '0:08:55', '-1'],
  ['3月14日', '0:08:38', '-1'],
  ['3月15日', '0:08:21', '-1'],
  ['3月16日', '0:08:04', '-1'],
  ['3月17日', '0:07:46', '-1'],
  ['3月18日', '0:07:29', '-1'],
  ['3月19日', '0:07:11', '-1'],
  ['3月20日', '0:06:53', '-1'],
  ['3月21日', '0:06:35', '-1'],
  ['3月22日', '0:06:17', '-1'],
  ['3月23日', '0:05:58', '-1'],
  ['3月24日', '0:05:40', '-1'],
  ['3月25日', '0:05:22', '-1'],
  ['3月26日', '0:05:04', '-1'],
  ['3月27日', '0:04:45', '-1'],
  ['3月28日', '0:04:27', '-1'],
  ['3月29日', '0:04:09', '-1'],
  ['3月30日', '0:03:51', '-1'],
  ['3月31日', '0:03:33', '-1'],

  ['4月1日', '0:03:16', '-1'],
  ['4月2日', '0:02:58', '-1'],
  ['4月3日', '0:02:41', '-1'],
  ['4月4日', '0:02:24', '-1'],
  ['4月5日', '0:02:07', '-1'],
  ['4月6日', '0:01:50', '-1'],
  ['4月7日', '0:01:33', '-1'],
  ['4月8日', '0:01:17', '-1'],
  ['4月9日', '0:01:01', '-1'],
  ['4月10日', '0:00:46', '1'],
  ['4月11日', '0:00:30', '1'],
  ['4月12日', '0:00:16', '1'],
  ['4月13日', '0:00:01', '1'],
  ['4月14日', '0:00:13', '1'],
  ['4月15日', '0:00:27', '1'],
  ['4月16日', '0:00:41', '1'],
  ['4月17日', '0:00:54', '1'],
  ['4月18日', '0:01:06', '1'],
  ['4月19日', '0:01:19', '1'],
  ['4月20日', '0:01:31', '1'],
  ['4月21日', '0:01:42', '1'],
  ['4月22日', '0:01:53', '1'],
  ['4月23日', '0:02:04', '1'],
  ['4月24日', '0:02:14', '1'],
  ['4月25日', '0:02:23', '1'],
  ['4月26日', '0:02:33', '1'],
  ['4月27日', '0:02:41', '1'],
  ['4月28日', '0:02:49', '1'],
  ['4月29日', '0:02:57', '1'],
  ['4月30日', '0:03:04', '1'],

  ['5月1日', '0:01:10', '1'],
  ['5月2日', '0:03:16', '1'],
  ['5月3日', '0:03:21', '1'],
  ['5月4日', '0:03:26', '1'],
  ['5月5日', '0:03:30', '1'],
  ['5月6日', '0:03:37', '1'],
  ['5月7日', '0:03:36', '1'],
  ['5月8日', '0:03:39', '1'],
  ['5月9日', '0:03:40', '1'],
  ['5月10日', '0:03:42', '1'],
  ['5月11日', '0:03:42', '1'],
  ['5月12日', '0:03:42', '1'],
  ['5月13日', '0:03:42', '1'],
  ['5月14日', '0:03:41', '1'],
  ['5月15日', '0:03:39', '1'],
  ['5月16日', '0:03:37', '1'],
  ['5月17日', '0:03:34', '1'],
  ['5月18日', '0:03:31', '1'],
  ['5月19日', '0:03:27', '1'],
  ['5月20日', '0:03:23', '1'],
  ['5月21日', '0:03:18', '1'],
  ['5月22日', '0:03:13', '1'],
  ['5月23日', '0:03:07', '1'],
  ['5月24日', '0:03:01', '1'],
  ['5月25日', '0:02:54', '1'],
  ['5月26日', '0:02:47', '1'],
  ['5月27日', '0:02:39', '1'],
  ['5月28日', '0:02:31', '1'],
  ['5月29日', '0:02:22', '1'],
  ['5月30日', '0:02:13', '1'],
  ['5月31日', '0:02:04', '1'],

  ['6月1日', '0:01:54', '1'],
  ['6月2日', '0:01:44', '1'],
  ['6月3日', '0:01:34', '1'],
  ['6月4日', '0:01:23', '1'],
  ['6月5日', '0:01:12', '1'],
  ['6月6日', '0:01:00', '1'],
  ['6月7日', '0:00:48', '1'],
  ['6月8日', '0:00:36', '1'],
  ['6月9日', '0:00:24', '1'],
  ['6月10日', '0:00:12', '1'],
  ['6月11日', '0:00:01', '1'],
  ['6月12日', '0:00:14', '1'],
  ['6月13日', '0:00:39', '1'],
  ['6月14日', '0:00:52', '1'],
  ['6月15日', '0:01:05', '-1'],
  ['6月16日', '0:01:18', '-1'],
  ['6月17日', '0:01:31', '-1'],
  ['6月18日', '0:01:45', '-1'],
  ['6月19日', '0:01:57', '-1'],
  ['6月20日', '0:02:10', '-1'],
  ['6月21日', '0:02:23', '-1'],
  ['6月22日', '0:02:36', '-1'],
  ['6月23日', '0:02:48', '-1'],
  ['6月24日', '0:03:01', '-1'],
  ['6月25日', '0:03:13', '-1'],
  ['6月26日', '0:03:25', '-1'],
  ['6月27日', '0:03:37', '-1'],
  ['6月28日', '0:03:49', '-1'],
  ['6月29日', '0:04:00', '-1'],
  ['6月30日', '0:04:11', '-1'],

  ['7月1日', '0:04:22', '-1'],
  ['7月2日', '0:04:33', '-1'],
  ['7月3日', '0:04:43', '-1'],
  ['7月4日', '0:04:53', '-1'],
  ['7月5日', '0:05:02', '-1'],
  ['7月6日', '0:05:11', '-1'],
  ['7月7日', '0:05:20', '-1'],
  ['7月8日', '0:05:28', '-1'],
  ['7月9日', '0:05:36', '-1'],
  ['7月10日', '0:05:43', '-1'],
  ['7月11日', '0:05:50', '-1'],
  ['7月12日', '0:05:56', '-1'],
  ['7月13日', '0:06:02', '-1'],
  ['7月14日', '0:06:08', '-1'],
  ['7月15日', '0:06:12', '-1'],
  ['7月16日', '0:06:16', '-1'],
  ['7月17日', '0:06:20', '-1'],
  ['7月18日', '0:06:23', '-1'],
  ['7月19日', '0:06:25', '-1'],
  ['7月20日', '0:06:27', '-1'],
  ['7月21日', '0:06:29', '-1'],
  ['7月22日', '0:06:29', '-1'],
  ['7月23日', '0:06:29', '-1'],
  ['7月24日', '0:06:29', '-1'],
  ['7月25日', '0:06:28', '-1'],
  ['7月26日', '0:06:26', '-1'],
  ['7月27日', '0:06:24', '-1'],
  ['7月28日', '0:06:21', '-1'],
  ['7月29日', '0:06:17', '-1'],
  ['7月30日', '0:06:13', '-1'],
  ['7月31日', '0:06:08', '-1'],

  ['8月1日', '0:06:03', '-1'],
  ['8月2日', '0:05:57', '-1'],
  ['8月3日', '0:05:51', '-1'],
  ['8月4日', '0:05:44', '-1'],
  ['8月5日', '0:05:36', '-1'],
  ['8月6日', '0:05:28', '-1'],
  ['8月7日', '0:05:19', '-1'],
  ['8月8日', '0:05:10', '-1'],
  ['8月9日', '0:05:00', '-1'],
  ['8月10日', '0:04:50', '-1'],
  ['8月11日', '0:04:39', '-1'],
  ['8月12日', '0:04:27', '-1'],
  ['8月13日', '0:04:15', '-1'],
  ['8月14日', '0:04:02', '-1'],
  ['8月15日', '0:03:49', '-1'],
  ['8月16日', '0:03:36', '-1'],
  ['8月17日', '0:03:21', '-1'],
  ['8月18日', '0:03:07', '-1'],
  ['8月19日', '0:02:51', '-1'],
  ['8月20日', '0:02:36', '-1'],
  ['8月21日', '0:02:20', '-1'],
  ['8月22日', '0:02:03', '-1'],
  ['8月23日', '0:01:47', '-1'],
  ['8月24日', '0:01:29', '-1'],
  ['8月25日', '0:01:12', '-1'],
  ['8月26日', '0:00:54', '1'],
  ['8月27日', '0:00:35', '1'],
  ['8月28日', '0:00:17', '1'],
  ['8月29日', '0:00:02', '1'],
  ['8月30日', '0:00:21', '1'],
  ['8月31日', '0:00:41', '1'],

  ['9月1日', '0:01:00', '1'],
  ['9月2日', '0:01:20', '1'],
  ['9月3日', '0:01:40', '1'],
  ['9月4日', '0:02:01', '1'],
  ['9月5日', '0:02:21', '1'],
  ['9月6日', '0:02:42', '1'],
  ['9月7日', '0:03:03', '1'],
  ['9月8日', '0:03:03', '1'],
  ['9月9日', '0:03:24', '1'],
  ['9月10日', '0:03:45', '1'],
  ['9月11日', '0:04:06', '1'],
  ['9月12日', '0:04:27', '1'],
  ['9月13日', '0:04:48', '1'],
  ['9月14日', '0:05:10', '1'],
  ['9月15日', '0:05:31', '1'],
  ['9月16日', '0:05:53', '1'],
  ['9月17日', '0:06:14', '1'],
  ['9月18日', '0:06:35', '1'],
  ['9月19日', '0:06:57', '1'],
  ['9月20日', '0:07:18', '1'],
  ['9月21日', '0:07:39', '1'],
  ['9月22日', '0:08:00', '1'],
  ['9月23日', '0:08:21', '1'],
  ['9月24日', '0:08:42', '1'],
  ['9月25日', '0:09:02', '1'],
  ['9月26日', '0:09:22', '1'],
  ['9月27日', '0:09:42', '1'],
  ['9月28日', '0:10:02', '1'],
  ['9月29日', '0:10:21', '1'],
  ['9月30日', '0:10:40', '1'],

  ['10月1日', '0:10:59', '1'],
  ['10月2日', '0:11:18', '1'],
  ['10月3日', '0:11:36', '1'],
  ['10月4日', '0:11:36', '1'],
  ['10月5日', '0:11:53', '1'],
  ['10月6日', '0:12:11', '1'],
  ['10月7日', '0:12:28', '1'],
  ['10月8日', '0:12:44', '1'],
  ['10月9日', '0:13:00', '1'],
  ['10月10日', '0:13:16', '1'],
  ['10月11日', '0:13:16', '1'],
  ['10月12日', '0:13:31', '1'],
  ['10月13日', '0:13:45', '1'],
  ['10月14日', '0:13:59', '1'],
  ['10月15日', '0:14:13', '1'],
  ['10月16日', '0:14:26', '1'],
  ['10月17日', '0:14:38', '1'],
  ['10月18日', '0:14:50', '1'],
  ['10月19日', '0:15:01', '1'],
  ['10月20日', '0:15:12', '1'],
  ['10月21日', '0:15:21', '1'],
  ['10月22日', '0:15:31', '1'],
  ['10月23日', '0:15:40', '1'],
  ['10月24日', '0:15:48', '1'],
  ['10月25日', '0:15:55', '1'],
  ['10月26日', '0:16:01', '1'],
  ['10月27日', '0:16:07', '1'],
  ['10月28日', '0:16:12', '1'],
  ['10月29日', '0:16:16', '1'],
  ['10月30日', '0:16:20', '1'],
  ['10月31日', '0:16:22', '1'],

  ['11月1日', '0:16:24', '1'],
  ['11月2日', '0:16:25', '1'],
  ['11月3日', '0:16:25', '1'],
  ['11月4日', '0:16:24', '1'],
  ['11月5日', '0:16:23', '1'],
  ['11月6日', '0:16:21', '1'],
  ['11月7日', '0:16:17', '1'],
  ['11月8日', '0:16:13', '1'],
  ['11月9日', '0:16:09', '1'],
  ['11月10日', '0:16:03', '1'],
  ['11月11日', '0:15:56', '1'],
  ['11月12日', '0:15:49', '1'],
  ['11月13日', '0:15:41', '1'],
  ['11月14日', '0:15:32', '1'],
  ['11月15日', '0:15:22', '1'],
  ['11月16日', '0:15:11', '1'],
  ['11月17日', '0:15:00', '1'],
  ['11月18日', '0:14:47', '1'],
  ['11月19日', '0:14:34', '1'],
  ['11月20日', '0:14:20', '1'],
  ['11月21日', '0:14:06', '1'],
  ['11月22日', '0:13:50', '1'],
  ['11月23日', '0:13:34', '1'],
  ['11月24日', '0:13:17', '1'],
  ['11月25日', '0:12:59', '1'],
  ['11月26日', '0:12:40', '1'],
  ['11月27日', '0:12:21', '1'],
  ['11月28日', '0:12:01', '1'],
  ['11月29日', '0:11:40', '1'],
  ['11月30日', '0:11:18', '1'],

  ['12月1日', '0:10:56', '1'],
  ['12月2日', '0:10:33', '1'],
  ['12月3日', '0:10:09', '1'],
  ['12月4日', '0:09:45', '1'],
  ['12月5日', '0:09:21', '1'],
  ['12月6日', '0:08:55', '1'],
  ['12月7日', '0:08:29', '1'],
  ['12月8日', '0:08:03', '1'],
  ['12月9日', '0:07:36', '1'],
  ['12月10日', '0:07:09', '1'],
  ['12月11日', '0:06:42', '1'],
  ['12月12日', '0:06:14', '1'],
  ['12月13日', '0:05:46', '1'],
  ['12月14日', '0:05:17', '1'],
  ['12月15日', '0:04:48', '1'],
  ['12月16日', '0:04:19', '1'],
  ['12月17日', '0:03:50', '1'],
  ['12月18日', '0:03:21', '1'],
  ['12月19日', '0:02:51', '1'],
  ['12月20日', '0:02:22', '1'],
  ['12月21日', '0:01:52', '1'],
  ['12月22日', '0:01:22', '1'],
  ['12月23日', '0:00:52', '1'],
  ['12月24日', '0:00:23', '1'],
  ['12月25日', '0:00:07', '1'],
  ['12月26日', '0:00:37', '1'],
  ['12月27日', '0:01:06', '-1'],
  ['12月28日', '0:01:36', '-1'],
  ['12月29日', '0:02:05', '-1'],
  ['12月30日', '0:02:34', '-1'],
  ['12月31日', '0:03:03', '-1'],
]

var blackwordList = {
  陈独秀: 2,
  项英: 2,
  朱德: 2,
  任弼时: 2,
  彭真: 2,
  张闻天: 2,
  彭德怀: 2,
  罗荣桓: 2,
  陈毅: 2,
  李富春: 2,
  刘伯承: 2,
  叶剑英: 2,
  陈伯达: 2,
  张春桥: 2,
  王洪文: 2,
  韦国清: 2,
  纪登奎: 2,
  汪东兴: 2,
  乌兰夫: 2,
  徐向前: 2,
  习仲勋: 2,
  王震: 2,
  邓颖超: 2,
  李德生: 2,
  田纪云: 2,
  李铁映: 2,
  李瑞环: 2,
  李锡铭: 2,
  宋平: 2,
  胡启立: 2,
  姚依林: 2,
  刘华清: 2,
  李岚清: 2,
  吴邦国: 2,
  邹家华: 2,
  陈希同: 2,
  姜春云: 2,
  钱其琛: 2,
  尉健行: 2,
  吴官正: 2,
  罗干: 2,
  黄菊: 2,
  王兆国: 2,
  回良玉: 2,
  刘淇: 2,
  刘云山: 2,
  吴仪: 2,
  陈良宇: 2,
  俞正声: 2,
  贺国强: 2,
  郭伯雄: 2,
  曹刚川: 2,
  曾庆红: 2,
  曾培炎: 2,
  王乐泉: 2,
  王岐山: 2,
  回良玉: 2,
  刘淇: 2,
  刘延东: 2,
  李源潮: 2,
  徐才厚: 2,
  薄熙来: 2,
  王沪宁: 2,
  刘奇葆: 2,
  许其亮: 2,
  孙春兰: 2,
  孙政才: 2,
  李建国: 2,
  张春贤: 2,
  范长龙: 2,
  孟建柱: 2,
  赵乐际: 2,
  胡春华: 2,
  栗战书: 2,
  郭金龙: 2,
  韩正: 2,
  丁薛祥: 2,
  刘鹤: 2,
  李希: 2,
  李鸿忠: 2,
  杨晓渡: 2,
  张又侠: 2,
  陈全国: 2,
  陈敏尔: 2,
  郭声琨: 2,
  黄坤明: 2,
  蔡奇: 2,
  薄一波: 2,
  杜青林: 2,
  赵洪祝: 2,
  陈希同: 2,
  郭声琨: 2,
  王忠禹: 2,
  陈至立: 2,
  梁光烈: 2,
  戴秉国: 2,
  常万全: 2,
  魏凤和: 2,
  肖捷: 2,
  赵克志: 2,
  主席: 2,
  总理: 2,
  常委: 2,
  检察院: 2,
  市长: 2,
  中共中央: 2,
  外交部: 2,
  国防部: 2,
  教育部: 2,
  财政部: 2,
  住建部: 2,
  军委: 2,
  孙中山: 2,
  蒋经国: 2,
  李登辉: 2,
  陈水扁: 2,
  马英九: 2,
  蔡英文: 2,
  董建华: 2,
  梁振英: 2,
  林郑月娥: 2,
  何厚铧: 2,
  89: 2,
  金日成: 2,
  金正日: 2,
  金正恩: 2,
  金三胖: 2,
  新疆棉: 2,
  陈红军: 2,
  陈祥榕: 2,
  肖思远: 2,
  王焯冉: 2,
  张培莉: 2,
  刘永清: 2,
  江绵恒: 2,
  江绵康: 2,
  '王冶坪 ': 2,
  江泽慧: 2,
  邓朴方: 2,
  邓榕: 2,
  邓质方: 2,
  朱云来: 2,
  胡海峰: 2,
  胡海清: 2,
  李小琳: 2,
  普京: 2,
  '弗拉基米尔·泽连斯基': 2,
  弗拉基米尔泽连斯基: 2,
  乌克兰总统: 2,
  梅德韦杰夫: 2,
  '奥列格·西涅古诺夫': 2,
  奥列格西涅古诺夫: 2,
  '德米特里·佩斯科夫': 2,
  德米特里佩斯科夫: 2,
  法国总理: 2,
  德国总统: 2,
  土耳其总理: 2,
  中国教徒: 2,
  统一教: 2,
  志洪李: 2,
  法轮: 2,
  轮法功: 2,
  三去车仑: 2,
  氵去车仑: 2,
  发论工: 2,
  法x功: 2,
  法0功: 2,
  轮子功: 2,
  车仑工力: 2,
  法lun: 2,
  fa轮: 2,
  法lg: 2,
  flg: 2,
  fl功: 2,
  大法弟子: 2,
  大纪元: 2,
  明慧网: 2,
  明慧周报: 2,
  伪火: 2,
  超越红墙: 2,
  真善忍: 2,
  藏字石: 2,
  人类灭亡进程表: 2,
  按照马雅历法: 2,
  促红细胞生成素: 2,
  胰岛素样生长因子: 2,
  testosterone: 2,
  strychnine: 2,
  新型毒品: 2,
  海洛因: 2,
  海luo因: 2,
  cocain: 2,
  麻古: 2,
  冰毒: 2,
  苯丙胺: 2,
  大麻: 2,
  安非他命: 2,
  腐败中国: 2,
  打倒中国: 2,
  打倒共产党: 2,
  打倒共产主义: 2,
  打倒胡锦涛: 2,
  打倒江泽民: 2,
  打倒江主席: 2,
  打倒李鹏: 2,
  打倒温家宝: 2,
  打倒中共: 2,
  抵制共产党: 2,
  抵制共产主义: 2,
  抵制胡锦涛: 2,
  抵制江泽民: 2,
  抵制江主席: 2,
  抵制李鹏: 2,
  抵制罗干: 2,
  抵制温家宝: 2,
  抵制中共: 2,
  抵制朱镕基: 2,
  灭亡中国: 2,
  亡党亡国: 2,
  粉碎四人帮: 2,
  激流中国: 2,
  贪污腐败: 2,
  强制拆除: 2,
  政治风波: 2,
  太子党: 2,
  上海帮: 2,
  北京帮: 2,
  清华帮: 2,
  红色贵族: 2,
  官匪: 2,
  独夫民贼: 2,
  官商勾结: 2,
  城管暴力执法: 2,
  一党执政: 2,
  宪法法院: 2,
  胡平: 2,
  贺卫方: 2,
  一党专制: 2,
  一党专政: 2,
  宪法法院: 2,
  张志新: 2,
  王炳章: 2,
  魏京生: 2,
  寻找林昭的灵魂: 2,
  谁是新中国: 2,
  讨伐中宣部: 2,
  异议人士: 2,
  民运人士: 2,
  chinesedemocracy: 2,
  选国家主席: 2,
  民一主: 2,
  宪政: 2,
  平反: 2,
  党章: 2,
  人木又: 2,
  中国人权: 2,
  中国新民党: 2,
  群体事件: 2,
  群体性事件: 2,
  上中央: 2,
  去中央: 2,
  联名上书: 2,
  截访: 2,
  上访: 2,
  访民: 2,
  游行: 2,
  you行: 2,
  官逼民反: 2,
  反共: 2,
  抗议: 2,
  焚烧中国国旗: 2,
  流血冲突: 2,
  灭共: 2,
  罢考: 2,
  罢工: 2,
  罢课: 2,
  罢运: 2,
  jie严: 2,
  五毛党: 2,
  '8的平方事件': 2,
  知道64: 2,
  八九年: 2,
  六四: 2,
  陆四: 2,
  198964: 2,
  '89年春夏之交': 2,
  '64惨案': 2,
  '4事件': 2,
  '64运动': 2,
  '64时期': 2,
  学潮: 2,
  xuechao: 2,
  坦克压大学生: 2,
  血洗京城: 2,
  王丹: 2,
  柴玲: 2,
  王超华: 2,
  侯德健: 2,
  丁子霖: 2,
  党的喉舌: 2,
  中华局域网: 2,
  新闻封锁: 2,
  封锁消息: 2,
  中国的陷阱: 2,
  境外媒体: 2,
  东森新闻网: 2,
  东森电视: 2,
  自由亚洲: 2,
  自由时报: 2,
  中国时报: 2,
  钓鱼岛: 2,
  '8341部队': 2,
  七大军区: 2,
  沈阳军区: 2,
  南京军区: 2,
  兰州军区: 2,
  印尼屠华: 2,
  印尼事件命: 2,
  蒋公纪念歌: 2,
  马英九: 2,
  苏贞昌: 2,
  台湾: 2,
  台湾共和国: 2,
  一中一台: 2,
  打台湾: 2,
  两岸战争: 2,
  攻占台湾: 2,
  支持台湾: 2,
  进攻台湾: 2,
  占领台湾: 2,
  统一台湾: 2,
  收复台湾: 2,
  登陆台湾: 2,
  解放台湾: 2,
  台湾独立: 2,
  解决台湾: 2,
  台湾问题: 2,
  台海问题: 2,
  台海危机: 2,
  台海统一: 2,
  台海战争: 2,
  台海局势: 2,
  中华联邦: 2,
  国民党: 2,
  x民党: 2,
  民进党: 2,
  闹独立: 2,
  热比娅: 2,
  伊力哈木: 2,
  阿旺晋美: 2,
  哒赖: 2,
  支持zd: 2,
  藏暴乱: 2,
  藏青会: 2,
  雪山狮子旗: 2,
  阴b: 2,
  幼交: 2,
  幼女: 2,
  玉乳: 2,
  玉穴: 2,
  抓胸: 2,
  自慰: 2,
  作爱: 2,
  欠干: 2,
  我日你: 2,
  爆你菊: 2,
  cao你: 2,
  贱比: 2,
  全家死绝: 2,
  精子: 2,
  射精: 2,
  强奸: 2,
  内裤: 2,
  高潮: 2,
  干死: 2,
  乱伦小: 2,
  美艳少妇: 2,
  迷奸粉: 2,
  迷奸药: 2,
  迷药: 2,
  骚货: 2,
  色b: 2,
  射爽: 2,
  射颜: 2,
  兽奸: 2,
  兽交: 2,
  手淫: 2,
  熟女: 2,
  体奸: 2,
  舔阴: 2,
  小逼: 2,
  小穴: 2,
  小xue: 2,
  胸推: 2,
  穴口: 2,
  颜射: 2,
  阳具: 2,
  要射了: 2,
  阴部: 2,
  阴唇: 2,
  阴道: 2,
  阴核: 2,
  阴户: 2,
  阿共: 2,
  共产主义幽灵: 2,
  恶党: 2,
  邪党: 2,
  共产专制: 2,
  共产王朝: 2,
  裆中央: 2,
  土共: 2,
  共匪: 2,
  共产党腐败: 2,
  仇共: 2,
  共产党专制: 2,
  共产党报应: 2,
  共产党末日: 2,
  communistparty: 2,
  zhengfu: 2,
  挡中央: 2,
  档中央: 2,
  中国zf: 2,
  中央zf: 2,
  中华帝国: 2,
  性交视频: 2,
  性交图片: 2,
  阴唇: 2,
  阴道: 2,
  阴户: 2,
  阴茎增大: 2,
  阴茎助勃: 2,
  陰道: 2,
  淫穴: 2,
  摇头丸: 2,
  迷药: 2,
  暴奸: 2,
  暴乳: 2,
  爆乳: 2,
  屄: 2,
  被操: 2,
  逼奸: 2,
  插暴: 2,
  操逼: 2,
  操黑: 2,
  操烂: 2,
  肏你: 2,
  操我: 2,
  插比: 2,
  插b: 2,
  插逼: 2,
  插你: 2,
  插我: 2,
  插阴: 2,
  潮吹: 2,
  潮喷: 2,
  吃精: 2,
  抽插: 2,
  扌由插: 2,
  抽一插: 2,
  大力抽送: 2,
  大乳: 2,
  肥逼: 2,
  粉穴: 2,
  干穴: 2,
  肛交: 2,
  肛门: 2,
  龟头: 2,
  豪乳: 2,
  黑逼: 2,
  后庭: 2,
  后穴: 2,
  鸡吧: 2,
  鸡巴: 2,
  脚交: 2,
  精液: 2,
  就去日: 2,
  巨屌: 2,
  巨奶: 2,
  巨乳: 2,
  菊穴: 2,
  口爆: 2,
  口交: 2,
  口射: 2,
  狂操: 2,
  狂插: 2,
  浪逼: 2,
  漏乳: 2,
  露b: 2,
  乱交: 2,
  轮操: 2,
  轮奸: 2,
  美逼: 2,
  美少妇: 2,
  美乳: 2,
  美腿: 2,
  美穴: 2,
  迷奸: 2,
  密穴: 2,
  蜜穴: 2,
  摸奶: 2,
  母奸: 2,
  奶子: 2,
  内射: 2,
  嫩逼: 2,
  嫩穴: 2,
  强jian: 2,
  强暴: 2,
  强奸处女: 2,
  拳交: 2,
  群交: 2,
  人妻: 2,
  人兽: 2,
  日逼: 2,
  日烂: 2,
  肉逼: 2,
  肉唇: 2,
  肉棍: 2,
  肉茎: 2,
  揉乳: 2,
  肉穴: 2,
  乳房: 2,
  乳沟: 2,
  乳交: 2,
  乳头: 2,
  骚逼: 2,
  骚比: 2,
  藏独立: 2,
  藏妇会: 2,
  藏青会: 2,
  藏字石: 2,
  穆斯林: 2,
  穆罕穆德: 2,
  江丑闻: 2,
  江嫡系: 2,
  江独裁: 2,
  江核心: 2,
  江黑心: 2,
  江胡内斗: 2,
  江祸心: 2,
  江家帮: 2,
  江绵恒: 2,
  江派: 2,
  和胡派: 2,
  江派人马: 2,
  江氏集团: 2,
  江氏家族: 2,
  江氏政治局: 2,
  江氏政治委员: 2,
  江太上: 2,
  江系人: 2,
  江系人马: 2,
  江宰民: 2,
  江贼民: 2,
  江主席: 2,
  麻果丸: 2,
  台湾独立: 2,
  台湾国: 2,
  台湾应该独立: 2,
  台湾有权独立: 2,
  天灭中共: 2,
  中共帮凶: 2,
  中共保命: 2,
  中共裁: 2,
  中共党文化: 2,
  中共腐败: 2,
  中共的血旗: 2,
  中共的罪恶: 2,
  中共帝国: 2,
  中共独裁: 2,
  中共封锁: 2,
  中共封网: 2,
  中共黑: 2,
  中共黑帮: 2,
  中共解体: 2,
  中共近期权力斗争: 2,
  中共恐惧: 2,
  中共权力斗争: 2,
  中共任用: 2,
  中共退党: 2,
  中共洗脑: 2,
  中共邪教: 2,
  中共邪毒素: 2,
  中共政治游戏: 2,
  肛交: 2,
  干穴: 2,
  粉穴: 2,
  肥逼: 2,
  荡妇: 2,
  大乳: 2,
  大力抽送: 2,
  抽一插: 2,
  扌由插: 2,
  吃精: 2,
  抽插: 2,
  潮喷: 2,
  潮吹: 2,
  插阴: 2,
  插我: 2,
  插你: 2,
  北京政权: 2,
  刘志军: 2,
  许宗衡: 2,
  李启红: 2,
  贪腐财富: 2,
  落马: 2,
  高官名单: 2,
  陈希同: 2,
  滥用职权: 2,
  开除党籍: 2,
  刘方仁: 2,
  以权谋私: 2,
  李嘉廷: 2,
  宋平顺: 2,
  黄瑶: 2,
  剥夺政治权利终身: 2,
  王昭耀: 2,
  剥夺政治权利: 2,
  杜世成: 2,
  沈图: 2,
  罗云光: 2,
  张辛泰: 2,
  王乐毅: 2,
  李纪周: 2,
  郑光迪: 2,
  郑筱萸: 2,
  留党察看: 2,
  官僚主义: 2,
  徐炳松: 2,
  王宝森: 2,
  孟庆平: 2,
  胡长清: 2,
  王怀忠: 2,
  刘维明: 2,
  刘志华: 2,
  周文吉: 2,
  王庆录广西: 2,
  广西政协: 2,
  中国交通: 2,
  高严国家电力: 2,
  刘金宝: 2,
  陈同海: 2,
  慕绥新: 2,
  吴振汉: 2,
  李宝金: 2,
  陈少勇: 2,
  黄松有: 2,
  王华元: 2,
  刘连昆: 2,
  骚穴: 2,
  爱液: 2,
  爆草: 2,
  暴乳: 2,
  爆乳: 2,
  屄: 2,
  被操: 2,
  逼奸: 2,
  插暴: 2,
  操逼: 2,
  操烂: 2,
  肏你: 2,
  肏死: 2,
  操死: 2,
  操我: 2,
  插比: 2,
  插b: 2,
  插逼: 2,
  肉棒: 2,
  乱奸: 2,
  习近平: 1,
  习大大: 1,
  习小小: 1,
  习中中: 1,
  小小平: 1,
  近大大: 1,
  平大大: 1,
  x大大: 1,
  近大大: 1,
  xidada: 1,
  xizhuxi: 1,
  xizong: 1,
  xjp: 1,
  大大: 1,
  jp大大: 1,
  jping: 1,
  习总: 1,
  近平总: 1,
  习近: 1,
  习jj: 1,
  习pp: 1,
  习sir: 1,
  jinping: 1,
  某习: 1,
  某平: 1,
  某近: 1,
  某大大: 1,
  习某: 1,
  习z: 1,
  习帝: 1,
  习武帝: 1,
  习jp: 1,
  习太子: 1,
  近平: 1,
  习远平: 1,
  习x: 1,
  近平习: 1,
  平近习: 1,
  平近: 1,
  习紧平: 1,
  习紧: 1,
  紧平: 1,
  紧平大大: 1,
  紧平boss: 1,
  近平boss: 1,
  近boss: 1,
  习boss: 1,
  习近: 1,
  习平: 1,
  习核心: 1,
  习core: 1,
  习主席: 1,
  习书记: 1,
  习boss: 1,
  习贼: 1,
  习猪: 1,
  习熊: 1,
  习明泽: 1,
  老习: 1,
  平总: 1,
  近平习: 1,
  近习: 1,
  '近平·习': 1,
  '平·习': 1,
  习维尼: 1,
  习维尼熊: 1,
  习兔子: 1,
  习兔: 1,
  习大: 1,
  习x: 1,
  习xx: 1,
  习彭: 1,
  习姐夫: 1,
  习相: 1,
  彭姐夫: 1,
  习近p: 1,
  习近ping: 1,
  习j平: 1,
  习jp: 1,
  习jping: 1,
  习jin平: 1,
  习jinp: 1,
  习jinping: 1,
  x近平: 1,
  x近p: 1,
  x近ping: 1,
  xj平: 1,
  xjp: 1,
  xjping: 1,
  xjin平: 1,
  xjinp: 1,
  xjinping: 1,
  xi近平: 1,
  xi近p: 1,
  xi近ping: 1,
  xij平: 1,
  xijp: 1,
  xijping: 1,
  xijin平: 1,
  xijinp: 1,
  xijinping: 1,
  温boss: 1,
  温加宝: 1,
  温x: 1,
  温总理: 1,
  温首相: 1,
  温宝宝: 1,
  温加饱: 1,
  温加保: 1,
  温云松: 1,
  温如春: 1,
  温家宝: 1,
  温家b: 1,
  温家bao: 1,
  温j宝: 1,
  温jb: 1,
  温jbao: 1,
  温jia宝: 1,
  温jiab: 1,
  温jiabao: 1,
  w家宝: 1,
  w家b: 1,
  w家bao: 1,
  wj宝: 1,
  wjb: 1,
  wjbao: 1,
  wjia宝: 1,
  wjiab: 1,
  wjiabao: 1,
  wen家宝: 1,
  wen家b: 1,
  wen家bao: 1,
  wenj宝: 1,
  wenjb: 1,
  wenjbao: 1,
  wenjia宝: 1,
  wenjiab: 1,
  wenjiabao: 1,
  胡x: 1,
  胡boss: 1,
  胡总: 1,
  胡王八: 1,
  胡boss: 1,
  胡惊涛: 1,
  胡景涛: 1,
  胡紧掏: 1,
  湖紧掏: 1,
  胡紧套: 1,
  锦涛: 1,
  胡派: 1,
  胡主席: 1,
  胡书记: 1,
  胡锦涛: 1,
  胡锦t: 1,
  胡锦tao: 1,
  胡j涛: 1,
  胡jt: 1,
  胡jtao: 1,
  胡jin涛: 1,
  胡jint: 1,
  胡jintao: 1,
  h锦涛: 1,
  h锦t: 1,
  h锦tao: 1,
  hj涛: 1,
  hjt: 1,
  hjtao: 1,
  hjin涛: 1,
  hjint: 1,
  hjintao: 1,
  hu锦涛: 1,
  hu锦t: 1,
  hu锦tao: 1,
  huj涛: 1,
  hujt: 1,
  hujtao: 1,
  hujin涛: 1,
  hujint: 1,
  hujintao: 1,
  民泽江: 1,
  江胡: 1,
  江主席: 1,
  江书记: 1,
  江书记: 1,
  江浙闽: 1,
  江沢民: 1,
  江浙民: 1,
  择民: 1,
  则民: 1,
  茳泽民: 1,
  zemin: 1,
  ze民: 1,
  江core: 1,
  江x: 1,
  江派: 1,
  江戏子: 1,
  江蛤蟆: 1,
  江某某: 1,
  江泽慧: 1,
  江贼: 1,
  江猪: 1,
  江氏集团: 1,
  江泽民: 1,
  江泽m: 1,
  江泽min: 1,
  江z民: 1,
  江zm: 1,
  江zmin: 1,
  江ze民: 1,
  江zem: 1,
  江zemin: 1,
  j泽民: 1,
  j泽m: 1,
  j泽min: 1,
  jz民: 1,
  jzm: 1,
  jzmin: 1,
  jze民: 1,
  Jzem: 1,
  jzemin: 1,
  jiang泽民: 1,
  jiang泽m: 1,
  jiang泽min: 1,
  jiangz民: 1,
  jiangzm: 1,
  jiangzmin: 1,
  jiangze民: 1,
  jiangzem: 1,
  jiangzemin: 1,
  小平: 1,
  邓矮子: 1,
  平小邓: 1,
  xiao平: 1,
  邓xp: 1,
  邓晓平: 1,
  邓南巡: 1,
  邓改革: 1,
  邓开放: 1,
  邓朴方: 1,
  邓主席: 1,
  邓书记: 1,
  邓小平: 1,
  邓小p: 1,
  邓小ping: 1,
  邓x平: 1,
  邓xp: 1,
  邓xping: 1,
  邓xiao平: 1,
  邓xiaop: 1,
  邓xiaoping: 1,
  d小平: 1,
  d小p: 1,
  d小ping: 1,
  dx平: 1,
  dxp: 1,
  dxping: 1,
  dxiao平: 1,
  dxiaop: 1,
  dxiaoping: 1,
  deng小平: 1,
  deng小p: 1,
  deng小ping: 1,
  dengx平: 1,
  dengxp: 1,
  dengxping: 1,
  dengxiao平: 1,
  dengxiaop: 1,
  dengxiaoping: 1,
  毛泽东: 1,
  猫泽东: 1,
  猫则东: 1,
  猫贼洞: 1,
  毛zd: 1,
  毛zx: 1,
  z东: 1,
  ze东: 1,
  泽d: 1,
  zedong: 1,
  毛太祖: 1,
  太祖: 1,
  毛相: 1,
  毛新宇: 1,
  主席画像: 1,
  毛爷爷: 1,
  毛泽东: 1,
  毛泽d: 1,
  毛泽dong: 1,
  毛z东: 1,
  毛zd: 1,
  毛zdong: 1,
  毛ze东: 1,
  毛zed: 1,
  毛zedong: 1,
  m泽东: 1,
  m泽d: 1,
  m泽dong: 1,
  mz东: 1,
  mzd: 1,
  mzdong: 1,
  mze东: 1,
  mzed: 1,
  mzedong: 1,
  mao泽东: 1,
  maozd: 1,
  maozdong: 1,
  maoze东: 1,
  maozed: 1,
  maozedong: 1,
  朱镕基: 1,
  朱容基: 1,
  朱镕鸡: 1,
  朱容鸡: 1,
  李鹏: 1,
  李peng: 1,
  里鹏: 1,
  李月月鸟: 1,
  华主席: 1,
  华国: 1,
  华国锋: 1,
  国锋: 1,
  彭丽媛: 1,
  丽媛: 1,
  彭麻麻: 1,
  彭妈妈: 1,
  胡耀邦: 1,
  耀邦: 1,
  赵紫阳: 1,
  紫阳: 1,
  周恩来: 1,
  恩来: 1,
  杨尚昆: 1,
  尚昆: 1,
  李先念: 1,
  朱德: 1,
  刘少奇: 1,
  少奇: 1,
  毛岸英: 1,
  岸英: 1,
  蛋炒饭: 1,
  江青: 1,
  王洪文: 1,
  张春桥: 1,
  江青: 1,
  姚文元: 1,
  李克强: 1,
  克强: 1,
  朱镕基: 1,
  榕基: 1,
  李鹏: 1,
  彭李艳: 1,
  栗战书: 1,
  战书: 1,
  汪洋: 1,
  王沪宁: 1,
  沪宁: 1,
  赵乐际: 1,
  乐际: 1,
  韩正: 1,
  吴邦国: 1,
  贾庆林: 1,
  李长春: 1,
  贺国强: 1,
  周永康: 1,
  张德江: 1,
  俞正声: 1,
  刘云山: 1,
  王岐山: 1,
  张高丽: 1,
  第一代领导人: 1,
  第二代领导人: 1,
  第三代领导人: 1,
  第四代领导人: 1,
  达赖: 1,
  喇嘛: 1,
  活佛: 1,
  李洪志: 1,
  法轮功: 1,
  藏独: 1,
  疆独: 1,
  台独: 1,
  港独: 1,
  废青: 1,
  蒋介石: 1,
  蒋校长: 1,
  李登辉: 1,
  蒋经国: 1,
  陈水扁: 1,
  阿扁: 1,
  韩正: 1,
  赵乐际: 1,
  李鸿忠: 1,
  王东明: 1,
  肖捷: 1,
  郑建邦: 1,
  丁仲礼: 1,
  郝明金: 1,
  蔡达峰: 1,
  何维: 1,
  武维华: 1,
  铁凝: 1,
  彭清华: 1,
  张庆伟: 1,
  洛桑江村: 1,
  '雪克来提·扎克尔': 1,
  雪克来提扎克尔: 1,
  雪克来提: 1,
  扎克尔: 1,
  刘奇: 1,
  李强: 1,
  丁薛祥: 1,
  何立峰: 1,
  张国清: 1,
  刘国中: 1,
  李尚福: 1,
  王小洪: 1,
  吴政隆: 1,
  谌贻琴: 1,
  秦刚: 1,
  王沪宁: 1,
  石泰峰: 1,
  胡春华: 1,
  沈跃跃: 1,
  王勇: 1,
  周强: 1,
  '帕巴拉·格列朗杰': 1,
  帕巴拉格列朗杰: 1,
  格列朗杰: 1,
  帕巴拉: 1,
  何厚铧: 1,
  梁振英: 1,
  巴特尔: 1,
  苏辉: 1,
  邵鸿: 1,
  高云龙: 1,
  陈武: 1,
  穆虹: 1,
  咸辉: 1,
  王东峰: 1,
  姜信治: 1,
  蒋作君: 1,
  何报翔: 1,
  王光谦: 1,
  秦博勇: 1,
  朱永新: 1,
  杨震: 1,
  张又侠: 1,
  何卫东: 1,
  李尚福: 1,
  刘振立: 1,
  苗华: 1,
  张升民: 1,
  刘金国: 1,
  张军: 1,
  应勇: 1,
  丁来杭: 1,
  于伟国: 1,
  于忠福: 1,
  万立骏: 1,
  卫小春: 1,
  马立群: 1,
  王可: 1,
  王刚: 1,
  王红: 1,
  王志民: 1,
  王希勤: 1,
  王学成: 1,
  王宝山: 1,
  王建武: 1,
  王洪祥: 1,
  王超: 1,
  王瑞贺: 1,
  王毅: 1,
  王巍: 1,
  方向: 1,
  巴音朝鲁: 1,
  巴莫曲布嫫: 1,
  邓秀新: 1,
  古小玉: 1,
  布小林: 1,
  叶赞平: 1,
  史耀斌: 1,
  冉博: 1,
  白尚成: 1,
  丛斌: 1,
  包信和: 1,
  吕世明: 1,
  吕忠梅: 1,
  吕建: 1,
  吕彩霞: 1,
  朱明春: 1,
  刘仓理: 1,
  刘修文: 1,
  刘俊臣: 1,
  闫傲霜: 1,
  江天亮: 1,
  江金权: 1,
  汤维建: 1,
  安立佳: 1,
  安兆庆: 1,
  许为钢: 1,
  许达哲: 1,
  许安标: 1,
  孙其信: 1,
  孙宪忠: 1,
  孙菊生: 1,
  杜小光: 1,
  杜家毫: 1,
  李宁: 1,
  李纪恒: 1,
  李钺锋: 1,
  李敬泽: 1,
  李锦斌: 1,
  李静海: 1,
  李慧琼: 1,
  李毅: 1,
  李巍: 1,
  杨永英: 1,
  杨关林: 1,
  杨振武: 1,
  杨晓超: 1,
  束为: 1,
  '肖开提·依明': 1,
  肖开提依明: 1,
  吴一戎: 1,
  吴立新: 1,
  吴杰明: 1,
  吴晶: 1,
  吴普特: 1,
  邱学强: 1,
  何平: 1,
  何新: 1,
  谷振春: 1,
  汪铁民: 1,
  '沙尔合提·阿汗': 1,
  沙尔合提阿汗: 1,
  沈金龙: 1,
  沈金强: 1,
  沈春耀: 1,
  沈政昌: 1,
  宋秀岩: 1,
  宋锐: 1,
  张太范: 1,
  张伟: 1,
  张守攻: 1,
  张轩: 1,
  张妹芝: 1,
  张勇: 1,
  张涛: 1,
  张道宏: 1,
  张嘉极: 1,
  陈福利: 1,
  武增: 1,
  苻彩香: 1,
  范骁骏: 1,
  林锐: 1,
  欧阳昌琼: 1,
  罗琦: 1,
  周亚宁: 1,
  周光权: 1,
  周敏: 1,
  庞丽娟: 1,
  底青云: 1,
  郑卫平: 1,
  郑功成: 1,
  郑军里: 1,
  郑建闽: 1,
  郝平: 1,
  胡晓犁: 1,
  钟山: 1,
  钟志华: 1,
  段春华: 1,
  信春鹰: 1,
  侯建国: 1,
  娄勤俭: 1,
  骆源: 1,
  秦生祥: 1,
  袁誉柏: 1,
  袁曙宏: 1,
  夏光: 1,
  钱前: 1,
  徐玉善: 1,
  徐永军: 1,
  徐晓: 1,
  徐辉: 1,
  翁杰明: 1,
  高开贤: 1,
  高友东: 1,
  高松: 1,
  郭树清: 1,
  郭振华: 1,
  郭雷: 1,
  唐华俊: 1,
  黄志贤: 1,
  黄明: 1,
  黄俊华: 1,
  曹鸿鸣: 1,
  鄂竟平: 1,
  鹿心社: 1,
  彭金辉: 1,
  蒋卓庆: 1,
  蒋超良: 1,
  景汉朝: 1,
  程林: 1,
  程京: 1,
  程学源: 1,
  傅自应: 1,
  谢经荣: 1,
  甄占民: 1,
  '嘉木样·洛桑久美·图丹却吉尼玛': 1,
  嘉木样洛桑久美图丹却吉尼玛: 1,
  赫捷: 1,
  鲜铁可: 1,
  雒树刚: 1,
  谭天星: 1,
  谭琳: 1,
  颜珂: 1,
  丁薛祥: 1,
  何立峰: 1,
  张国清: 1,
  刘国中: 1,
  李尚福: 1,
  王小洪: 1,
  吴政隆: 1,
  谌贻琴: 1,
  秦刚: 1,
  吴政隆: 1,
  秦刚: 1,
  李尚福: 1,
  郑栅洁: 1,
  怀进鹏: 1,
  王志刚: 1,
  金壮龙: 1,
  潘岳: 1,
  王小洪: 1,
  陈一新: 1,
  唐登杰: 1,
  贺荣: 1,
  刘昆: 1,
  王晓萍: 1,
  王广华: 1,
  黄润秋: 1,
  倪虹: 1,
  李小鹏: 1,
  李国英: 1,
  唐仁健: 1,
  王文涛: 1,
  胡和平: 1,
  马晓伟: 1,
  裴金佳: 1,
  王祥喜: 1,
  '易纲 ': 1,
  侯凯: 1,
  王沪宁: 1,
  石泰峰: 1,
  胡春华: 1,
  沈跃跃: 1,
  王勇: 1,
  周强: 1,
  '帕巴拉·格列朗杰': 1,
  何厚铧: 1,
  梁振英: 1,
  巴特尔: 1,
  苏辉: 1,
  邵鸿: 1,
  高云龙: 1,
  陈武: 1,
  穆虹: 1,
  咸辉: 1,
  王东峰: 1,
  姜信治: 1,
  蒋作君: 1,
  何报翔: 1,
  王光谦: 1,
  秦博勇: 1,
  朱永新: 1,
  杨震: 1,
  王东峰: 1,
  乙晓光: 1,
  丁世忠: 1,
  万建民: 1,
  马文亮: 1,
  马军胜: 1,
  马建堂: 1,
  王宁: 1,
  王军: 1,
  王辰: 1,
  王俊: 1,
  王绚: 1,
  王锐: 1,
  王路: 1,
  王飚: 1,
  王世杰: 1,
  王尔乘: 1,
  王红玲: 1,
  王志刚: 1,
  王国生: 1,
  王金南: 1,
  王学典: 1,
  王建军: 1,
  王晓东: 1,
  王梅祥: 1,
  王惠贞: 1,
  王新强: 1,
  韦维: 1,
  韦朝晖: 1,
  扎西达娃: 1,
  车俊: 1,
  方光华: 1,
  方精云: 1,
  户思社: 1,
  孔令智: 1,
  邓蓉玲: 1,
  石碧: 1,
  石爱中: 1,
  龙庄伟: 1,
  卢柯: 1,
  卢国懿: 1,
  申长雨: 1,
  田红旗: 1,
  田沁鑫: 1,
  冉霞: 1,
  印红: 1,
  冯正霖: 1,
  宁吉喆: 1,
  司马红: 1,
  '吉尔拉·衣沙木丁': 1,
  吉尔拉衣沙木丁: 1,
  朴世龙: 1,
  成岳冲: 1,
  毕井泉: 1,
  朱生岭: 1,
  朱程清: 1,
  多杰热旦: 1,
  刘艳: 1,
  刘雷: 1,
  刘聪: 1,
  刘万龙: 1,
  刘中民: 1,
  刘同德: 1,
  刘旭光: 1,
  刘忠范: 1,
  刘政奎: 1,
  刘结一: 1,
  刘晓梅: 1,
  刘家义: 1,
  刘家强: 1,
  刘雅煌: 1,
  刘赐贵: 1,
  刘德伟: 1,
  齐扎拉: 1,
  齐成喜: 1,
  江广平: 1,
  江尔雄: 1,
  江利平: 1,
  许又声: 1,
  许京军: 1,
  阮成发: 1,
  阮诗玮: 1,
  孙尧: 1,
  孙阳: 1,
  孙东生: 1,
  孙业礼: 1,
  孙继业: 1,
  寿子琪: 1,
  杜占元: 1,
  李山: 1,
  李卫: 1,
  李心: 1,
  李林: 1,
  李群: 1,
  李瑶: 1,
  李小鹏: 1,
  李文章: 1,
  李世杰: 1,
  李龙熙: 1,
  李光富: 1,
  李仲平: 1,
  李玛琳: 1,
  李和平: 1,
  李宝善: 1,
  李家杰: 1,
  李家洋: 1,
  李惠东: 1,
  杨杰: 1,
  杨云彦: 1,
  杨发明: 1,
  杨光跃: 1,
  杨华勇: 1,
  杨振斌: 1,
  杨培君: 1,
  吴巍: 1,
  吴为山: 1,
  吴良好: 1,
  吴社洲: 1,
  吴英杰: 1,
  吴国华: 1,
  吴建平: 1,
  邱达昌: 1,
  邱华栋: 1,
  何平: 1,
  何志敏: 1,
  何润生: 1,
  何超琼: 1,
  但彦铮: 1,
  邹加怡: 1,
  邹其国: 1,
  沈斌: 1,
  宋涛: 1,
  宋亚君: 1,
  宋曙光: 1,
  迟子建: 1,
  张全: 1,
  张杰: 1,
  张光奇: 1,
  张兴凯: 1,
  张兴海: 1,
  张纪南: 1,
  张克俭: 1,
  张来斌: 1,
  张连起: 1,
  张伯军: 1,
  张灼华: 1,
  张雨东: 1,
  张宗真: 1,
  张柏青: 1,
  张复明: 1,
  张桃林: 1,
  张晓明: 1,
  张恩迪: 1,
  张宽寿: 1,
  张雪樵: 1,
  张裔炯: 1,
  张福成: 1,
  张震宇: 1,
  陆桂华: 1,
  '阿地里江·阿吉克力木': 1,
  阿地里江阿吉克力木: 1,
  陈冬: 1,
  陈旭: 1,
  陈军: 1,
  陈彦: 1,
  陈群: 1,
  陈小平: 1,
  陈小江: 1,
  陈马林: 1,
  陈冯富珍: 1,
  陈宝生: 1,
  陈星莺: 1,
  陈贵云: 1,
  陈润儿: 1,
  武向平: 1,
  苗圩: 1,
  苟仲文: 1,
  范九伦: 1,
  林铎: 1,
  林建岳: 1,
  林毅夫: 1,
  欧阳明高: 1,
  欧阳泽华: 1,
  尚勇: 1,
  尚勋武: 1,
  易军: 1,
  易纲: 1,
  帕松列龙庄勐: 1,
  金石: 1,
  周汉民: 1,
  周忠和: 1,
  郑和: 1,
  郑永飞: 1,
  房兴耀: 1,
  赵吉: 1,
  赵雯: 1,
  赵静: 1,
  赵宗岐: 1,
  赵家军: 1,
  赵德明: 1,
  胡刚: 1,
  胡泽君: 1,
  南存辉: 1,
  '哈德尔别克·哈木扎': 1,
  哈德尔别克哈木扎: 1,
  侯茂丰: 1,
  施荣怀: 1,
  洪捷序: 1,
  洪慧民: 1,
  祝春秀: 1,
  姚志胜: 1,
  姚爱兴: 1,
  秦顺全: 1,
  '珠康·土登克珠': 1,
  珠康土登克珠: 1,
  '班禅额尔德尼·确吉杰布': 1,
  班禅额尔德尼确吉杰布: 1,
  袁亚湘: 1,
  聂辰席: 1,
  贾楠: 1,
  贾庆国: 1,
  夏杰: 1,
  夏先鹏: 1,
  钱锋: 1,
  钱克明: 1,
  钱学明: 1,
  钱智民: 1,
  倪晋仁: 1,
  徐涛: 1,
  徐彬: 1,
  徐令义: 1,
  徐乐江: 1,
  徐延豪: 1,
  徐启方: 1,
  徐晓兰: 1,
  徐晓鸿: 1,
  栾新: 1,
  高津: 1,
  高峰: 1,
  高小玫: 1,
  高永文: 1,
  高秀梅: 1,
  高鸿钧: 1,
  郭乃硕: 1,
  席南华: 1,
  唐英年: 1,
  唐承沛: 1,
  陶智: 1,
  陶凯元: 1,
  黄卫: 1,
  黄武: 1,
  黄荣: 1,
  黄震: 1,
  黄宇光: 1,
  黄丽云: 1,
  黄国显: 1,
  黄柳权: 1,
  黄润秋: 1,
  曹卫星: 1,
  龚建明: 1,
  龚俊龙: 1,
  盛斌: 1,
  常凯: 1,
  崔世昌: 1,
  符之冠: 1,
  康耀红: 1,
  隋军: 1,
  葛会波: 1,
  葛均波: 1,
  葛建团: 1,
  董耀鹏: 1,
  蒋旭光: 1,
  蒋建国: 1,
  韩卫国: 1,
  韩立平: 1,
  程红: 1,
  程凯: 1,
  程萍: 1,
  程永波: 1,
  傅振邦: 1,
  焦红: 1,
  舒红兵: 1,
  谢红: 1,
  谢茹: 1,
  谢晓亮: 1,
  赖明: 1,
  赖明勇: 1,
  解冬: 1,
  蔡威: 1,
  蔡名照: 1,
  蔡秀军: 1,
  蔡冠深: 1,
  廖长江: 1,
  演觉: 1,
  谭铁牛: 1,
  谭锦球: 1,
  樊杰: 1,
  黎昌晋: 1,
  滕树静: 1,
  潘立刚: 1,
  燕瑛: 1,
  霍卫平: 1,
  霍金花: 1,
  魏钢: 1,
  张又侠: 1,
  何卫东: 1,
  李尚福: 1,
  刘振立: 1,
  苗华: 1,
  张升民: 1,
  刘金国: 1,
  张军: 1,
  应勇: 1,
  习: 1,
  书记: 1,
}

const blackwordList_net = []

export default {
  lunarYears,
  lunarInfo,
  monthArray,
  dayArray,
  ShiChaXiuZheng,
  blackwordList,
  blackwordList_net,
}
